import {profCourse} from 'constants/url';
import {AddWith2ParamsOptions} from '../../../../components/grid-dx/types';
import {useAddWith2ParamsOptions} from './index';

function useAddProfileSpacInProfCourse() {
  const addCollaboratorInAttended = useAddWith2ParamsOptions(profCourse, null);
  return (addWith2ParamsOptions: AddWith2ParamsOptions) =>
    addCollaboratorInAttended(addWith2ParamsOptions);
}

export default useAddProfileSpacInProfCourse;
